import ptBR from './pt-BR.json';

const messages = {
  ptBR,
};

export { messages };
